import { type Market } from '@bridebook/toolbox/src/gazetteer';
import { formatDate } from '../elastic-sync/utils/dateUtils';
import { mapToDateRange } from './map-to-date-range';
import { IDatePickerUI } from './types';

/**
 * Function `mapToExactDate`
 * map DatepickerDate to a full string to be used across the website
 *
 * @function mapToExactDate
 * @param market
 * @param datePickerDate
 * @returns {String}
 */
const mapToExactDate = (datePickerDate: IDatePickerUI | null, market: Market): string => {
  if (!datePickerDate) return '';

  const dateRange = mapToDateRange(datePickerDate, market);

  return dateRange ? formatDate(dateRange.from) : '';
};

export default mapToExactDate;

/**
 * Function `mapToExactTimestamp`
 * map DatepickerDate to a timestamp in ms to be used across the analytics
 *
 * @function mapToExactTimestamp
 * @param datePickerDate
 * @param market
 * @returns {Number}
 */
export const mapToExactTimestamp = (
  datePickerDate: IDatePickerUI | null,
  market: Market,
): number | null => {
  if (!datePickerDate) return null;

  const dateRange = mapToDateRange(datePickerDate, market);

  return dateRange ? dateRange.from.getTime() : null;
};
